/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Container,
  Pagination,
  Box,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Button,
} from "@mui/material";
import TableHorizontal from "../TableHorizontal";
import api from "../../services/api";
export default function ListOrderStatus() {
  const [pageState, setPageState] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [orderStatus, setOrderStatus] = useState([]);
  const columns = ["ID", "Code", "Name", "Action", "Delete"];
  const keys = ["id", "code", "name", "action", "delete"];

  const fetchData = async (
    page = 1,
    languageFilter = 1,
    numberItemsPerPage = 500
  ) => {
    await api
      .get(
        `/order-status?page=${page}&limit=${numberItemsPerPage}&language_id=${languageFilter}&search=${searchFilter}`
      )
      .then((res) => {
        setOrderStatus(res.data.items);
        setTotalPages(res.data.total_pages);
      });
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageState(value);
    fetchData(value, Number(languageFilter), Number(numberItemsPerPage));
  };
  const [numberItemsPerPage, setNumberItemsPerPage] = useState("500");
  const handleNumberItemsPerPage = (event: SelectChangeEvent) => {
    setNumberItemsPerPage(event.target.value);
    fetchData(1, Number(languageFilter), Number(event.target.value));
  };

  const [languageFilter, setLanguageFilter] = useState(0);
  const handleChangeLanguageFilter = (event: SelectChangeEvent) => {
    setLanguageFilter(Number(event.target.value));
    fetchData(1, Number(event.target.value), Number(numberItemsPerPage));
  };

  const [languages, setLanguages] = useState<{ id: number; name: string }[]>(
    []
  );
  const fetchLanguages = async () => {
    const response = await api.get(`languages`);
    setLanguages(response.data.items);
    setLanguageFilter(1);
  };

  const [searchFilter, setSearchFilter] = useState("");

  const handleSearchClick = () => {
    fetchData(1, Number(languageFilter), Number(numberItemsPerPage));
  };

  useEffect(() => {
    fetchData();
    fetchLanguages();
  }, []);
  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <Box style={{ display: "flex", flexDirection: "row" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
          }}
        >
          <InputLabel id="number-items-page-label">
            Number of Items per Page
          </InputLabel>
          <Select
            labelId="number-items-page-select-label"
            id="number-items-page"
            value={numberItemsPerPage}
            label="Number of Items per Page"
            onChange={handleNumberItemsPerPage}
          >
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={250}>250</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={750}>750</MenuItem>
            <MenuItem value={1000}>1000</MenuItem>
          </Select>
        </Box>
        <Box>
          <InputLabel id="language-label">Language</InputLabel>
          <Select
            labelId="language-select-label"
            id="language"
            value={String(languageFilter)}
            label="Language"
            onChange={handleChangeLanguageFilter}
          >
            <MenuItem value={0}>None</MenuItem>
            {languages.map((language, index) => (
              <MenuItem value={language.id} key={index}>
                {language.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
            marginTop: "22px",
          }}
        >
          <TextField
            // sx={{ minWidth: 1 / 4, marginLeft: "8px" }}
            id={"search-filter-input"}
            type="text"
            label="Search"
            defaultValue={searchFilter}
            onBlur={(e) => setSearchFilter(e.target.value)}
          />
        </Box>
        <Button
          variant="contained"
          sx={{ m: 3 }}
          href=""
          onClick={handleSearchClick}
        >
          Filter
        </Button>
      </Box>
      <TableHorizontal
        screen={"order-status"}
        columns={columns}
        data={orderStatus}
        objectKey={keys}
      />
      <Box
        display="flex"
        width={"100%"}
        height={80}
        alignItems="center"
        justifyContent="center"
      >
        <Pagination
          count={totalPages}
          page={pageState}
          onChange={handleChange}
        />
      </Box>
    </Container>
  );
}
